/** Browser/desktop notifications for Team updates (tab-in-background). */

export function canUseDesktopNotifications(): boolean {
  return typeof window !== 'undefined' && 'Notification' in window;
}

export function ensureDesktopNotificationPermission(): void {
  if (!canUseDesktopNotifications()) return;
  if (Notification.permission === 'default') {
    void Notification.requestPermission().catch(() => {
      // Permission prompt dismissed — ignore
    });
  }
}

export function showDesktopTeamUpdateNotification(options: {
  title: string;
  body: string;
  tag: string;
  onClick?: () => void;
}): void {
  if (!canUseDesktopNotifications()) return;
  if (Notification.permission !== 'granted') return;
  // Prefer in-app snackbar when the tab is visible
  if (typeof document !== 'undefined' && !document.hidden) return;

  try {
    const notification = new Notification(options.title, {
      body: options.body,
      tag: options.tag,
      // `renotify` is supported in Chromium but missing from TS DOM libs.
      renotify: true,
    } as NotificationOptions);
    notification.onclick = () => {
      window.focus();
      options.onClick?.();
      notification.close();
    };
  } catch {
    // Some browsers throw if permission flips mid-session
  }
}
